import { Box } from '@n26/nxd'
import { useEffect, useState } from 'react'
import { useTrackGTMScrollPercentage } from '@hooks/useTrackGTMScrollPercentage'

export const ProgressBar = () => {
  const [progress, setProgress] = useState<number>(0)
  useEffect(() => {
    const handleScroll = () => {
      const scrollOffset = window.scrollY
      const windowHeight = window.innerHeight
      const fullHeight = document.body.scrollHeight

      const currentProgress = Math.floor(
        (scrollOffset / (fullHeight - windowHeight)) * 100
      )
      setProgress(currentProgress)
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useTrackGTMScrollPercentage(progress)

  return (
    <Box className='relative bottom-12 z-[1000] bg-neutral h-4'>
      <progress
        max='100'
        value={progress}
        className='w-full h-4 [&::-webkit-progress-bar]:bg-neutral [&::-webkit-progress-value]:bg-teal [&::-moz-progress-bar]:bg-teal '
      />
    </Box>
  )
}
